import { InjectionToken } from '@angular/core';

import { Environment } from '../../../environments/models/environment.model';

type AppConfig = Environment;

const APP_CONFIG = new InjectionToken<AppConfig>('appConfig');

export { APP_CONFIG };
export type { AppConfig };
